import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

function UserLoading() {
    const { t } = useTranslation('main', { keyPrefix: 'login' });
    return (
        <Container>
            <ShortcutSkeleton/>
            <Divider/>
            <ShortcutSkeleton/>
            <Divider/>
            <ShortcutSkeleton/>
        </Container>
    );
}

function ShortcutSkeleton() {
    return (
        <ShortcutContainer align='center' spacing={1}>
            <Skeleton height={68} shape='block'/>
        </ShortcutContainer>
    );
}

const ShortcutContainer = styled(Column)`
    flex: 1;
`;

const Container = styled.div`
    align-items: center;
    background-color: var(--color-white);
    column-gap: var(--spacing-1);
    display: flex;
    padding: var(--spacing-3) var(--spacing-2);
    margin: 0 var(--spacing-4);
    width: calc(100% - var(--spacing-8));
`;

const Divider = styled.div`
    background-color: var(--color-border-default);
    flex-shrink: 0;
    height: 40px;
    width: 1px;
`;

export default UserLoading;
